// eslint-disable-next-line import/no-unresolved
import { logEvent } from 'firebase/analytics';
import { analytics } from '../config/firebase';

export const ANALYTICS_EVENTS = {
	// Pattern maker funnel
	PATTERN_MAKER_IMAGE_UPLOADED: 'pattern_maker_image_uploaded',
	PATTERN_MAKER_IMAGE_ERROR: 'pattern_maker_image_error',
	PATTERN_MAKER_LIBRARY_IMAGE_LOADED: 'pattern_maker_library_image_loaded',
	PATTERN_MAKER_DIMENSIONS_SUBMITTED: 'pattern_maker_dimensions_submitted',
	PATTERN_MAKER_SAMPLE_GENERATED: 'pattern_maker_sample_generated',
	PATTERN_MAKER_PRICING_VIEWED: 'pattern_maker_pricing_viewed',
	PATTERN_MAKER_CHECKOUT_INITIATED: 'pattern_maker_checkout_initiated',

	// Purchase flow
	CHECKOUT_SESSION_CREATED: 'checkout_session_created',
	STRIPE_REDIRECT_INITIATED: 'stripe_redirect_initiated',
	PATTERN_RESULT_PAGE_LOADED: 'pattern_result_page_loaded',
	PATTERN_GENERATION_SUCCEEDED: 'pattern_generation_succeeded',
	PATTERN_GENERATION_FAILED: 'pattern_generation_failed',
	PATTERN_GENERATION_RETRY: 'pattern_generation_retry',
	PATTERN_NOT_YET_PAID_RETRY: 'pattern_not_yet_paid_retry',

	// Auth
	AUTH_SIGN_IN_SUCCESS: 'auth_sign_in_success',
	AUTH_SIGN_UP_SUCCESS: 'auth_sign_up_success',
	AUTH_SIGN_OUT: 'auth_sign_out',
	AUTH_PASSWORD_RESET_SENT: 'auth_password_reset_sent',

	// Errors
	APP_ERROR: 'app_error',
};

export const ERROR_CONTEXTS = {
	// Auth
	SIGN_IN: 'useAuth.signIn',
	SIGN_UP: 'useAuth.signUp',
	SEND_PASSWORD_RESET: 'useAuth.sendPasswordReset',

	// Pattern generation
	TOKEN_REFRESH: 'pattern.service.tokenRefresh',
	CALL_GENERATE_PATTERN: 'pattern.service.callGeneratePattern',
	USE_GENERATE_PATTERN: 'useGeneratePattern.generatePattern',
	FETCH_PARAMS: 'usePattern.fetchParams',

	// Purchase
	CREATE_CHECKOUT_SESSION: 'purchase.service.createPatternCheckoutSession',
	PURCHASE_PATTERN: 'usePurchasePattern.purchasePattern',
	PRICE_CARD_SUBSCRIPTION: 'PriceCard.purchaseSubscription',
	PRICE_CARD_ONE_TIME: 'PriceCard.purchaseOneTime',
	PRICE_CARD_SINGLE: 'PriceCard.purchaseSinglePattern',

	// Pattern result page
	PATTERN_RESULT_RETRY: 'PatternResultPage.retryWithBackoff',
	PATTERN_RESULT_RETRY_EXHAUSTED:
		'PatternResultPage.retryWithBackoff.exhausted',
	PATTERN_RESULT_GENERATE: 'PatternResultPage.generateAndRedirect',

	// Account
	LOGOUT: 'Logout.handleClick',
	FORGOT_PASSWORD: 'ForgotPassword.resetPassword',
	PASSWORD_RESET: 'PasswordReset.onClick',

	// Library
	ADD_LIBRARY_PATTERN: 'AddLibraryPattern.upload',
};

const isDev = process.env.NODE_ENV === 'development';

function trackEvent(eventName, params = {}) {
	if (isDev) {
		// eslint-disable-next-line no-console
		console.log('[analytics]', eventName, params);
	}
	try {
		logEvent(analytics, eventName, params);
	} catch (error) {
		if (isDev) {
			// eslint-disable-next-line no-console
			console.warn(
				'[analytics] logEvent failed',
				eventName,
				params,
				error,
			);
		}
	}
}

function trackError(context, error, params = {}) {
	trackEvent(ANALYTICS_EVENTS.APP_ERROR, {
		context,
		error_message: error?.message ?? String(error),
		error_code: error?.code ?? null,
		...params,
	});
}

function trackPatternMakerStep(step, params = {}) {
	trackEvent(step, params);
}

function trackPurchaseEvent(event, params = {}) {
	trackEvent(event, params);
}

function trackAuthEvent(event, params = {}) {
	trackEvent(event, params);
}

export {
	trackEvent,
	trackError,
	trackPatternMakerStep,
	trackPurchaseEvent,
	trackAuthEvent,
};
